import React from 'react';
import { Broadcast, CircleNotch, Prohibit, Trash } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

export const PatientsBulkActionBar = ({
  selectedCount, onClear, onBulkDelete, bulkDeleting,
  canManageAutomation = false, onEnrollAutomation, onUnenrollAutomation,
}) => {
  if (selectedCount === 0) return null;
  return (
    <Card className="border-indigo-200 bg-indigo-50" data-testid="patients-bulk-action-bar">
      <CardContent className="py-3 flex items-center justify-between flex-wrap gap-2">
        <span className="text-sm font-medium text-indigo-800">
          {selectedCount} patient{selectedCount > 1 ? 's' : ''} selected
        </span>
        <div className="flex gap-2 flex-wrap">
          <Button variant="outline" size="sm" onClick={onClear} data-testid="clear-selection-btn">
            Clear
          </Button>
          {canManageAutomation && (
            <>
              <Button
                variant="outline"
                size="sm"
                className="border-emerald-300 text-emerald-800 hover:bg-emerald-50"
                onClick={onEnrollAutomation}
                data-testid="bulk-enroll-270-btn"
              >
                <Broadcast size={14} className="mr-1" /> Enable 270 automation
              </Button>
              <Button
                variant="outline"
                size="sm"
                className="border-amber-300 text-amber-800 hover:bg-amber-50"
                onClick={onUnenrollAutomation}
                data-testid="bulk-unenroll-270-btn"
              >
                <Prohibit size={14} className="mr-1" /> Disable 270 automation
              </Button>
            </>
          )}
          <Button
            variant="destructive"
            size="sm"
            onClick={onBulkDelete}
            disabled={bulkDeleting}
            data-testid="bulk-delete-btn"
          >
            {bulkDeleting
              ? <CircleNotch size={14} className="mr-1 animate-spin" />
              : <Trash size={14} className="mr-1" />}
            Delete {selectedCount}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PatientsBulkActionBar;
